<template>
  <ts-modal
    data-title="Change Parent Tenant"
    data-size="medium"
    :data-visible="visible || null"
    @close="$emit('close')"
  >
    <!-- eslint-disable vue/no-deprecated-slot-attribute -->
    <div class="content" slot="main">
      <h2>Select new parent tenant</h2>
      <ts-typography variant="subtitle" no-tootltip="">
        You can search by the Tenant ID or company name.
      </ts-typography>

      <br />

      <ts-search
        id="search"
        placeholder="Search for Company ID or Company name"
        @idle="searchTenant"
      ></ts-search>

      <br />

      <ts-spinner
        data-message="Loading..."
        data-size="medium"
        :data-visible="isLoading || null"
      ></ts-spinner>

      <div v-for="company in companies" :key="company.CompanyName">
        <ts-list-item
          :title="company.CompanyName"
          :subtitle="`ID: ${company.CompanyAccountId}`"
          selectable="true"
          :selected="isSelected(company)"
          @click="selectedParent = company"
        ></ts-list-item>
      </div>
    </div>

    <div class="footer" slot="footer">
      <ts-button @click="$emit('close')">Cancel</ts-button>
      <ts-button
        data-testid="confirmSelectionBtn"
        type="primary"
        :disabled="!selectedParent"
        @click="changeParentTenant"
      >
        Confirm Selection
      </ts-button>
    </div>
    <!-- eslint-enable vue/no-deprecated-slot-attribute -->
  </ts-modal>
</template>

<script>
import axios from 'axios';
import { blockingLoader, notify } from '../../../utils';
import '@tradeshift/elements.button';
import '@tradeshift/elements.modal';
import '@tradeshift/elements.search';
import '@tradeshift/elements.spinner';
import '@tradeshift/elements.typography';
import '@tradeshift/elements/src/vars.css';

export default {
  props: {
    visible: { type: Boolean, default: true },
    tenantId: { type: String, default: null },
  },
  emits: ['close', 'change-tenant-parent'],
  data() {
    return {
      companies: [],
      isLoading: false,
      selectedParent: undefined,
    };
  },
  methods: {
    searchTenant(event) {
      this.companies = [];
      const searchString = event.target.value;

      if (!searchString) {
        this.selectedParent = undefined;

        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      const uuidRegex = /^[\w\d]{8}-[\w\d]{4}-[\w\d]{4}-[\w\d]{4}-[\w\d]{12}$/i;
      const searchType = uuidRegex.test(searchString)
        ? 'company_uuid'
        : 'network';

      return axios
        .post('/support/search', {
          search_string: searchString,
          search_type: searchType,
        })
        .then(({ data: { data: result } }) => {
          this.companies = result;
        })
        .catch((error) => {
          notify.failed(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    isSelected(company) {
      return this.selectedParent
        ? company.CompanyAccountId === this.selectedParent.CompanyAccountId
        : false;
    },
    changeParentTenant() {
      if (!this.selectedParent) {
        return;
      }
      blockingLoader.show();
      axios
        .put('/support/tenant/parent', {
          parent_id: this.selectedParent.CompanyAccountId,
          tenant_id: this.tenantId,
        })
        .then(() => {
          this.$emit('change-tenant-parent', this.selectedParent);
          notify.succeeded('Parent tenant was successfully updated.');
          const tenantId = this.tenantId;
          axios.get(`/support/tenant/${tenantId}/access`).catch(() => {
            notify.info('You lost access request again', {
              onclose() {
                window.location.href = `/support/tenant/${tenantId}`;
              },
            });
          });
        })
        .catch((error) => notify.failed(error, 'Could not update the parent'))
        .finally(() => blockingLoader.hide());
    },
  },
};
</script>

<style scoped>
.content {
  max-width: 500px;
  margin: auto;
}

.footer {
  background-color: var(--ts-color-gray-lightest);
  padding: var(--ts-unit-half);
  text-align: right;
}
</style>
